<template>
    <div class="page">
        <div class="workspace">
            <div class="ws-unit">
                <div class="ws-unit-header ">
                    <div>
                    </div>
                    <div class="ws-unit-toolbar">
                        <el-form :inline="true">
                            <el-form-item>
                                <el-radio-group
                                    v-model="filter.state"
                                    size="mini"
                                    @change="onSearch()"
                                >
                                    <el-radio-button label="所有"></el-radio-button>
                                    <el-radio-button label="待处理"></el-radio-button>
                                    <el-radio-button label="已通过"></el-radio-button>
                                    <el-radio-button label="已拒绝"></el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="ws-unit-body">
                    <admin-table ref="table" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdminTable from "./Table";

export default {
    name: "Admin",
    components: {
        AdminTable
    },
    data: function() {
        return {
            filter: {
                state: "所有",
                column: "_username",
                keyword: null,
            }
        };
    },
    mounted() {
      const query = new window.BaaS.Query();
      query.compare('category','=','demand');
      this.$ox.service('domain').find(query,{select:['name'], orderBy:['prior']}).then(res=>{
        this.domains = res.objects.map(d=>d.name);
      })
    },
    methods: {
        onSearch() {
            this.$refs.table.loadData(1);
        }
    }
};
</script>

<style scoped>
</style>